import { useRouter } from 'expo-router'
import { Platform } from 'react-native'

import { GENERAL_NOTIFICATION_SETTINGS } from '@/src/features/notification/models/notification.constants'
import { useNotificationSettingsQuery } from '@/src/features/notification/services/useNotificationSettingsQuery'
import { useXMRPMRedirect } from '@/src/features/rosario/services/useXMRPMRedirect'
import { ONE_DAY_IN_MS } from '@/src/general/constants/time'
import { storage } from '@/src/general/utilities/storage'
import { STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'
import { isIOSWeb } from '@/src/general/utils/isIOSWeb'
import { useRoutes } from '@/src/general/utils/routes'

type TWatchmanPushCtaHistory = {
  lastRequestDateMs?: number
}

const getWatchmanPushCtaHistory = (): TWatchmanPushCtaHistory => {
  try {
    const watchmanPushCtaHistory = JSON.parse(storage.getItem(STORAGE_KEYS.WATCHMAN_PUSH_CTA) || '{}')
    return typeof watchmanPushCtaHistory === 'object' ? watchmanPushCtaHistory : {}
  } catch (_error) {
    return {}
  }
}

const saveWatchmanPushCtaHistory = (history: TWatchmanPushCtaHistory) =>
  storage.setItem(STORAGE_KEYS.WATCHMAN_PUSH_CTA, JSON.stringify(history))

export const useWatchmanRewardOnFinish = () => {
  const router = useRouter()
  const { routes } = useRoutes()
  const finishRedirect = useXMRPMRedirect({ destination: routes['prayer-space']() })
  const { data } = useNotificationSettingsQuery()

  const hasActivatedWatchmanNotifications = data?.[GENERAL_NOTIFICATION_SETTINGS.ON_INTENTION_WATCHMAN].push

  return () => {
    const now = Date.now()
    const { lastRequestDateMs = 0 } = getWatchmanPushCtaHistory()

    const hasWaitedEnoughAfterLastDisplay = !lastRequestDateMs || now - lastRequestDateMs >= 30 * ONE_DAY_IN_MS

    if (
      Platform.OS !== 'ios' &&
      !isIOSWeb() &&
      hasWaitedEnoughAfterLastDisplay &&
      hasActivatedWatchmanNotifications === false
    ) {
      saveWatchmanPushCtaHistory({ lastRequestDateMs: now })
      router.navigate(routes.watchmanPushCta())
    } else {
      router.dismissTo(finishRedirect)
    }
  }
}
